import { useEffect, useState } from 'react';
import { Table, Card, Select, Button, message, Typography, Space, Popconfirm, Tag, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title } = Typography;
const fmt = (v) => Number(v || 0).toLocaleString('uz-UZ');
const STATUS = { pending: 'Kutilmoqda', confirmed: 'Tasdiqlangan', in_progress: 'Jarayonda', completed: 'Bajarilgan', cancelled: 'Bekor' };
const STATUS_COLOR = { pending: 'orange', confirmed: 'blue', in_progress: 'cyan', completed: 'green', cancelled: 'red' };

export default function GovOrdersPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(null);

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (statusFilter) params.status = statusFilter;
      const r = await api.get('/admingov/orders', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(1); }, []);
  useEffect(() => { fetchData(1); }, [statusFilter]);

  const changeStatus = async (id, status) => {
    try {
      await api.put(`/admingov/orders/${id}`, { status });
      message.success('Yangilandi'); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/admingov/orders/${id}`);
      message.success("O'chirildi"); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Xizmat', dataIndex: 'service_name' },
    { title: 'Biznes', dataIndex: 'business_name' },
    { title: 'Mijoz', dataIndex: 'user_name' },
    { title: 'Summa', dataIndex: 'summa', render: v => fmt(v) + " so'm" },
    { title: 'Sana', render: (_, r) => r.day && r.month && r.year ? `${r.day}.${String(r.month).padStart(2,'0')}.${r.year}` : '-' },
    {
      title: 'Status', dataIndex: 'status',
      render: (s, r) => (
        <Select size="small" value={s} onChange={v => changeStatus(r.id, v)} style={{ width: 130 }}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v, value: k }))}
        />
      )
    },
    {
      title: 'Amal', width: 60,
      render: (_, r) => (
        <Popconfirm title="O'chirish?" onConfirm={() => handleDelete(r.id)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Title level={3}>Buyurtmalar boshqaruvi</Title>
      <Card style={{ borderRadius: 12, marginBottom: 16 }}>
        <Select placeholder="Status bo'yicha" allowClear style={{ width: 200 }} value={statusFilter} onChange={setStatusFilter}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v, value: k }))} />
      </Card>
      <Card style={{ borderRadius: 12 }}>
        <Table
          dataSource={data} columns={columns} rowKey="id" loading={loading} size="small" scroll={{ x: 800 }}
          pagination={{ current: page, total, pageSize: 20, onChange: p => { setPage(p); fetchData(p); } }}
        />
      </Card>
    </div>
  );
}
